// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksPerformanceResponse implements flatbuffers.IUnpackableObject<AllBanksPerformanceResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksPerformanceResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksPerformanceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksPerformanceResponse,
  ): AllBanksPerformanceResponse {
    return (obj || new AllBanksPerformanceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksPerformanceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksPerformanceResponse,
  ): AllBanksPerformanceResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksPerformanceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  bankName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  bankType(): string;
  bankType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  bankType(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  liftsCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  availability(): string;
  availability(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  availability(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  beneficial(): string;
  beneficial(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  beneficial(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  utilization(): string;
  utilization(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  utilization(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  uptimePercentage(): string;
  uptimePercentage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  uptimePercentage(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  downtimePercentage(): string;
  downtimePercentage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  downtimePercentage(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  activeLiftsPercentage(): string;
  activeLiftsPercentage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  activeLiftsPercentage(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  idleTimePercentage(): string;
  idleTimePercentage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  idleTimePercentage(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  uptimeSeconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  downtimeSeconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  totalSeconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  activeSeconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  idleSeconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksPerformanceResponse(builder: flatbuffers.Builder) {
    builder.startObject(16);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addBankType(builder: flatbuffers.Builder, bankTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankTypeOffset, 0);
  }

  static addLiftsCount(builder: flatbuffers.Builder, liftsCount: number) {
    builder.addFieldInt32(2, liftsCount, 0);
  }

  static addAvailability(builder: flatbuffers.Builder, availabilityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, availabilityOffset, 0);
  }

  static addBeneficial(builder: flatbuffers.Builder, beneficialOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, beneficialOffset, 0);
  }

  static addUtilization(builder: flatbuffers.Builder, utilizationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, utilizationOffset, 0);
  }

  static addUptimePercentage(
    builder: flatbuffers.Builder,
    uptimePercentageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, uptimePercentageOffset, 0);
  }

  static addDowntimePercentage(
    builder: flatbuffers.Builder,
    downtimePercentageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(7, downtimePercentageOffset, 0);
  }

  static addActiveLiftsPercentage(
    builder: flatbuffers.Builder,
    activeLiftsPercentageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(8, activeLiftsPercentageOffset, 0);
  }

  static addIdleTimePercentage(
    builder: flatbuffers.Builder,
    idleTimePercentageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(9, idleTimePercentageOffset, 0);
  }

  static addUptimeSeconds(builder: flatbuffers.Builder, uptimeSeconds: bigint) {
    builder.addFieldInt64(10, uptimeSeconds, 0n);
  }

  static addDowntimeSeconds(builder: flatbuffers.Builder, downtimeSeconds: bigint) {
    builder.addFieldInt64(11, downtimeSeconds, 0n);
  }

  static addTotalSeconds(builder: flatbuffers.Builder, totalSeconds: bigint) {
    builder.addFieldInt64(12, totalSeconds, 0n);
  }

  static addActiveSeconds(builder: flatbuffers.Builder, activeSeconds: bigint) {
    builder.addFieldInt64(13, activeSeconds, 0n);
  }

  static addIdleSeconds(builder: flatbuffers.Builder, idleSeconds: bigint) {
    builder.addFieldInt64(14, idleSeconds, 0n);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(15, bankId, 0);
  }

  static endAllBanksPerformanceResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_name
    builder.requiredField(offset, 6); // bank_type
    builder.requiredField(offset, 10); // availability
    builder.requiredField(offset, 12); // beneficial
    builder.requiredField(offset, 14); // utilization
    builder.requiredField(offset, 16); // uptime_percentage
    builder.requiredField(offset, 18); // downtime_percentage
    builder.requiredField(offset, 20); // active_lifts_percentage
    builder.requiredField(offset, 22); // idle_time_percentage
    return offset;
  }

  static createAllBanksPerformanceResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    bankTypeOffset: flatbuffers.Offset,
    liftsCount: number,
    availabilityOffset: flatbuffers.Offset,
    beneficialOffset: flatbuffers.Offset,
    utilizationOffset: flatbuffers.Offset,
    uptimePercentageOffset: flatbuffers.Offset,
    downtimePercentageOffset: flatbuffers.Offset,
    activeLiftsPercentageOffset: flatbuffers.Offset,
    idleTimePercentageOffset: flatbuffers.Offset,
    uptimeSeconds: bigint,
    downtimeSeconds: bigint,
    totalSeconds: bigint,
    activeSeconds: bigint,
    idleSeconds: bigint,
    bankId: number,
  ): flatbuffers.Offset {
    AllBanksPerformanceResponse.startAllBanksPerformanceResponse(builder);
    AllBanksPerformanceResponse.addBankName(builder, bankNameOffset);
    AllBanksPerformanceResponse.addBankType(builder, bankTypeOffset);
    AllBanksPerformanceResponse.addLiftsCount(builder, liftsCount);
    AllBanksPerformanceResponse.addAvailability(builder, availabilityOffset);
    AllBanksPerformanceResponse.addBeneficial(builder, beneficialOffset);
    AllBanksPerformanceResponse.addUtilization(builder, utilizationOffset);
    AllBanksPerformanceResponse.addUptimePercentage(builder, uptimePercentageOffset);
    AllBanksPerformanceResponse.addDowntimePercentage(builder, downtimePercentageOffset);
    AllBanksPerformanceResponse.addActiveLiftsPercentage(builder, activeLiftsPercentageOffset);
    AllBanksPerformanceResponse.addIdleTimePercentage(builder, idleTimePercentageOffset);
    AllBanksPerformanceResponse.addUptimeSeconds(builder, uptimeSeconds);
    AllBanksPerformanceResponse.addDowntimeSeconds(builder, downtimeSeconds);
    AllBanksPerformanceResponse.addTotalSeconds(builder, totalSeconds);
    AllBanksPerformanceResponse.addActiveSeconds(builder, activeSeconds);
    AllBanksPerformanceResponse.addIdleSeconds(builder, idleSeconds);
    AllBanksPerformanceResponse.addBankId(builder, bankId);
    return AllBanksPerformanceResponse.endAllBanksPerformanceResponse(builder);
  }

  unpack(): AllBanksPerformanceResponseT {
    return new AllBanksPerformanceResponseT(
      this.bankName(),
      this.bankType(),
      this.liftsCount(),
      this.availability(),
      this.beneficial(),
      this.utilization(),
      this.uptimePercentage(),
      this.downtimePercentage(),
      this.activeLiftsPercentage(),
      this.idleTimePercentage(),
      this.uptimeSeconds(),
      this.downtimeSeconds(),
      this.totalSeconds(),
      this.activeSeconds(),
      this.idleSeconds(),
      this.bankId(),
    );
  }

  unpackTo(_o: AllBanksPerformanceResponseT): void {
    _o.bankName = this.bankName();
    _o.bankType = this.bankType();
    _o.liftsCount = this.liftsCount();
    _o.availability = this.availability();
    _o.beneficial = this.beneficial();
    _o.utilization = this.utilization();
    _o.uptimePercentage = this.uptimePercentage();
    _o.downtimePercentage = this.downtimePercentage();
    _o.activeLiftsPercentage = this.activeLiftsPercentage();
    _o.idleTimePercentage = this.idleTimePercentage();
    _o.uptimeSeconds = this.uptimeSeconds();
    _o.downtimeSeconds = this.downtimeSeconds();
    _o.totalSeconds = this.totalSeconds();
    _o.activeSeconds = this.activeSeconds();
    _o.idleSeconds = this.idleSeconds();
    _o.bankId = this.bankId();
  }

  unpackFields(...fields: string[]): AllBanksPerformanceResponseT {
    const t = new AllBanksPerformanceResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("bank_type")) {
      t.bankType = this.bankType();
    }
    if (fieldSet.has("lifts_count")) {
      t.liftsCount = this.liftsCount();
    }
    if (fieldSet.has("availability")) {
      t.availability = this.availability();
    }
    if (fieldSet.has("beneficial")) {
      t.beneficial = this.beneficial();
    }
    if (fieldSet.has("utilization")) {
      t.utilization = this.utilization();
    }
    if (fieldSet.has("uptime_percentage")) {
      t.uptimePercentage = this.uptimePercentage();
    }
    if (fieldSet.has("downtime_percentage")) {
      t.downtimePercentage = this.downtimePercentage();
    }
    if (fieldSet.has("active_lifts_percentage")) {
      t.activeLiftsPercentage = this.activeLiftsPercentage();
    }
    if (fieldSet.has("idle_time_percentage")) {
      t.idleTimePercentage = this.idleTimePercentage();
    }
    if (fieldSet.has("uptime_seconds")) {
      t.uptimeSeconds = this.uptimeSeconds();
    }
    if (fieldSet.has("downtime_seconds")) {
      t.downtimeSeconds = this.downtimeSeconds();
    }
    if (fieldSet.has("total_seconds")) {
      t.totalSeconds = this.totalSeconds();
    }
    if (fieldSet.has("active_seconds")) {
      t.activeSeconds = this.activeSeconds();
    }
    if (fieldSet.has("idle_seconds")) {
      t.idleSeconds = this.idleSeconds();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    return t;
  }
}

export class AllBanksPerformanceResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public bankType: string | Uint8Array | null = null,
    public liftsCount: number = 0,
    public availability: string | Uint8Array | null = null,
    public beneficial: string | Uint8Array | null = null,
    public utilization: string | Uint8Array | null = null,
    public uptimePercentage: string | Uint8Array | null = null,
    public downtimePercentage: string | Uint8Array | null = null,
    public activeLiftsPercentage: string | Uint8Array | null = null,
    public idleTimePercentage: string | Uint8Array | null = null,
    public uptimeSeconds: bigint = 0n,
    public downtimeSeconds: bigint = 0n,
    public totalSeconds: bigint = 0n,
    public activeSeconds: bigint = 0n,
    public idleSeconds: bigint = 0n,
    public bankId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankName === null || this.bankName === undefined) {
      throw new Error('Required field "bank_name" is not set');
    }
    if (this.bankType === null || this.bankType === undefined) {
      throw new Error('Required field "bank_type" is not set');
    }
    if (this.availability === null || this.availability === undefined) {
      throw new Error('Required field "availability" is not set');
    }
    if (this.beneficial === null || this.beneficial === undefined) {
      throw new Error('Required field "beneficial" is not set');
    }
    if (this.utilization === null || this.utilization === undefined) {
      throw new Error('Required field "utilization" is not set');
    }
    if (this.uptimePercentage === null || this.uptimePercentage === undefined) {
      throw new Error('Required field "uptime_percentage" is not set');
    }
    if (this.downtimePercentage === null || this.downtimePercentage === undefined) {
      throw new Error('Required field "downtime_percentage" is not set');
    }
    if (this.activeLiftsPercentage === null || this.activeLiftsPercentage === undefined) {
      throw new Error('Required field "active_lifts_percentage" is not set');
    }
    if (this.idleTimePercentage === null || this.idleTimePercentage === undefined) {
      throw new Error('Required field "idle_time_percentage" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const bankType = this.bankType !== null ? builder.createString(this.bankType!) : 0;
    const availability = this.availability !== null ? builder.createString(this.availability!) : 0;
    const beneficial = this.beneficial !== null ? builder.createString(this.beneficial!) : 0;
    const utilization = this.utilization !== null ? builder.createString(this.utilization!) : 0;
    const uptimePercentage =
      this.uptimePercentage !== null ? builder.createString(this.uptimePercentage!) : 0;
    const downtimePercentage =
      this.downtimePercentage !== null ? builder.createString(this.downtimePercentage!) : 0;
    const activeLiftsPercentage =
      this.activeLiftsPercentage !== null ? builder.createString(this.activeLiftsPercentage!) : 0;
    const idleTimePercentage =
      this.idleTimePercentage !== null ? builder.createString(this.idleTimePercentage!) : 0;

    return AllBanksPerformanceResponse.createAllBanksPerformanceResponse(
      builder,
      bankName,
      bankType,
      this.liftsCount,
      availability,
      beneficial,
      utilization,
      uptimePercentage,
      downtimePercentage,
      activeLiftsPercentage,
      idleTimePercentage,
      this.uptimeSeconds,
      this.downtimeSeconds,
      this.totalSeconds,
      this.activeSeconds,
      this.idleSeconds,
      this.bankId,
    );
  }

  clone(): AllBanksPerformanceResponseT {
    const obj = new AllBanksPerformanceResponseT();
    obj.bankName = this.bankName;
    obj.bankType = this.bankType;
    obj.liftsCount = this.liftsCount;
    obj.availability = this.availability;
    obj.beneficial = this.beneficial;
    obj.utilization = this.utilization;
    obj.uptimePercentage = this.uptimePercentage;
    obj.downtimePercentage = this.downtimePercentage;
    obj.activeLiftsPercentage = this.activeLiftsPercentage;
    obj.idleTimePercentage = this.idleTimePercentage;
    obj.uptimeSeconds = this.uptimeSeconds;
    obj.downtimeSeconds = this.downtimeSeconds;
    obj.totalSeconds = this.totalSeconds;
    obj.activeSeconds = this.activeSeconds;
    obj.idleSeconds = this.idleSeconds;
    obj.bankId = this.bankId;
    return obj;
  }

  equals(other: AllBanksPerformanceResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.bankType !== other.bankType) return false;
    if (this.liftsCount !== other.liftsCount) return false;
    if (this.availability !== other.availability) return false;
    if (this.beneficial !== other.beneficial) return false;
    if (this.utilization !== other.utilization) return false;
    if (this.uptimePercentage !== other.uptimePercentage) return false;
    if (this.downtimePercentage !== other.downtimePercentage) return false;
    if (this.activeLiftsPercentage !== other.activeLiftsPercentage) return false;
    if (this.idleTimePercentage !== other.idleTimePercentage) return false;
    if (this.uptimeSeconds !== other.uptimeSeconds) return false;
    if (this.downtimeSeconds !== other.downtimeSeconds) return false;
    if (this.totalSeconds !== other.totalSeconds) return false;
    if (this.activeSeconds !== other.activeSeconds) return false;
    if (this.idleSeconds !== other.idleSeconds) return false;
    if (this.bankId !== other.bankId) return false;
    return true;
  }
}

export function verifyAllBanksPerformanceResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_type");
    verifier.checkScalarField(tablePos, 8, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "availability");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "beneficial");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "utilization");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 16, "uptime_percentage");
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 18, "downtime_percentage");
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 20, "active_lifts_percentage");
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 22, "idle_time_percentage");
    verifier.checkScalarField(tablePos, 24, 8);
    verifier.checkScalarField(tablePos, 26, 8);
    verifier.checkScalarField(tablePos, 28, 8);
    verifier.checkScalarField(tablePos, 30, 8);
    verifier.checkScalarField(tablePos, 32, 8);
    verifier.checkScalarField(tablePos, 34, 2);
  } finally {
    verifier.popDepth();
  }
}
